// React
import { useEffect, useState, useContext } from "react";
import { useQuery, gql, useMutation } from "@apollo/client";

// Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftButton from "components/SoftButton";
import ModalDelete from "components/Modals/Delete";
import { Card, Grid, Icon, Tooltip, Menu, MenuItem, Select, InputLabel } from "@mui/material";

// Data
import Loading from "components/Carteles/Loading";
import DataTable from "components/Tables/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import CustomPagination from "components/Pagination";
import { getColor } from "utils/colors";
import SoftInput from "components/SoftInput";
import ModalAdd from "./ModalAdd";
import { MessageManager } from "context";
import { UserContext } from "context/user";
import dataPermisos from "./data/dataPermisos";
import { API_URL } from "services/config";
import ModalPermisoPDF from "./PermisoPDF";

function PermisosOcCoto() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [selectedPermiso, setSelectedPermiso] = useState(null);
  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });
  const [orderBy, setOrderBy] = useState({
    campo: "id",
    orden: "DESC",
  });
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [filtro, setFiltro] = useState({
    tipo: "todos",
  });

  const [openModalPDF, setOpenModalPDF] = useState(false);

  const { handleSnackbar } = useContext(MessageManager);
  const { verificarAcceso } = useContext(UserContext);
  const { columns, getRows } = dataPermisos;

  const handleOrderBy = (campo) => {
    if (orderBy.campo === campo) {
      if (orderBy.orden === "ASC") {
        setOrderBy({
          campo: campo,
          orden: "DESC",
        });
      } else {
        setOrderBy({
          campo: campo,
          orden: "ASC",
        });
      }
    } else {
      setOrderBy({
        campo: campo,
        orden: "ASC",
      });
    }
  };

  const handleOpenMenu = (event, item) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSelectedPermiso(item);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleSearch = (event) => {
    const newTimeout = setTimeout(() => {
      setSearch(event.target.value);
      setPage(1);
    }, 500);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchTimeout(newTimeout);
  };

  const [deletePermisoOcCoto] = useMutation(
    gql`
      mutation deletePermisoOcCoto($id: ID!) {
        deletePermisoOcCoto(id: $id) {
          id
        }
      }
    `
  );

  const { loading, error, data, refetch } = useQuery(
    gql`
      query permisosOcCoto($search: String, $page: Int, $order: Order, $filter: JSON) {
        paginationInfo {
          pages
          total
        }
        permisosOcCoto(
          search: $search
          pagination: { page: $page, limit: 10 }
          order: $order
          filter: $filter
        ) {
          id
          tipo
          url
          personaHabilitada
          dni
          domicilio
          fechaDesde
          fechaHasta
          valorPermisoTemporada
          importeAbonado
          nroPermiso
          anioPermiso
          file
        }
      }
    `,
    {
      variables: {
        search: search || null,
        page: page,
        order: { field: orderBy.campo, order: orderBy.orden },
        filter: {
          tipo: filtro.tipo === "todos" ? undefined : filtro.tipo,
        },
      },
      fetchPolicy: "no-cache",
      cachePolicy: "no-cache",
    }
  );

  const renderMenu = (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem
        disabled={!verificarAcceso(3) || selectedPermiso?.tipoUser === "Administrador"}
        onClick={() => {
          setOpenModalPDF(true);
          handleCloseMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Permiso</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color:
                  selectedPermiso?.tipoUser === "Administrador"
                    ? getColor()
                    : getColor("gobPrimary"),
              }}
            >
              file_open
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      {/* <MenuItem
        disabled={!verificarAcceso(3) || selectedPermiso?.tipoUser === "Administrador"}
        onClick={() => {
          window.open(`${API_URL}/${selectedPermiso?.file}`, "_blank");
          handleCloseMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Comprobante</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color:
                  selectedPermiso?.tipoUser === "Administrador"
                    ? getColor()
                    : getColor("gobPrimary"),
              }}
            >
              article
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem> */}
      <MenuItem
        disabled={!verificarAcceso(3) || selectedPermiso?.tipoUser === "Administrador"}
        onClick={() => {
          setOpenModalDelete(true);
          handleCloseMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Eliminar</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color:
                  selectedPermiso?.tipoUser === "Administrador"
                    ? getColor()
                    : getColor("gobPrimary"),
              }}
            >
              delete
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  useEffect(() => {
    if (data) {
      setRows(getRows(data?.permisosOcCoto, handleOpenMenu));
      setPagesInfo(data.paginationInfo);
    }
  }, [data]);

  const handleDeletePermiso = async (id) => {
    try {
      await deletePermisoOcCoto({ variables: { id: id } });
      handleSnackbar("Permiso eliminado correctamente");
      refetch();
    } catch (error) {
      handleSnackbar("Ocurrió un error al eliminar el permiso");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox>
          <Card>
            <Grid container spacing={2} p={3}>
              <Grid item xs={12}>
                <SoftBox
                  display={{
                    sm: "flex-row",
                    xl: "flex",
                  }}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox mr={1} display="flex" alignItems="center">
                        <SoftBox
                          display="grid"
                          justifyContent="center"
                          alignItems="center"
                          bgColor="primary"
                          color="white"
                          width="3rem"
                          height="3rem"
                          shadow="md"
                          borderRadius="lg"
                          variant="gradient"
                        >
                          <Icon fontSize="default">forest</Icon>
                        </SoftBox>
                      </SoftBox>
                      <SoftBox
                        display="flex-row"
                        alignItems="center"
                        sx={{
                          lineHeight: 0,
                        }}
                      >
                        <SoftTypography variant="h6" fontWeight="bold">
                          Permisos operador cinegético y coto
                        </SoftTypography>
                        <SoftTypography variant="caption" fontWeight="regular">
                          {pagesInfo?.total
                            ? `${pagesInfo?.total} permiso${pagesInfo?.total > 1 ? "s" : ""}`
                            : "No hay permisos"}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                    <SoftBox
                      display={{
                        xs: "block",
                        sm: "none",
                      }}
                    >
                      <Tooltip title="Agregar nuevo permiso" placement="top">
                        <SoftButton
                          color="primary"
                          iconOnly
                          onClick={() => setOpenModalAdd(true)}
                          disabled={!verificarAcceso(1)}
                        >
                          <Icon>add</Icon>
                        </SoftButton>
                      </Tooltip>
                    </SoftBox>
                  </SoftBox>
                  <SoftBox
                    display="flex"
                    alignItems="flex-end"
                    justifyContent="end"
                    mt={{
                      xs: 2,
                      sm: 0,
                    }}
                    flexDirection={{
                      xs: "column",
                      sm: "row",
                    }}
                  >
                    <SoftBox
                      mr={{
                        xs: 0,
                        sm: 2,
                      }}
                      sx={{
                        width: {
                          xs: "100%",
                          xl: "auto",
                        },
                      }}
                    >
                      <InputLabel htmlFor="tipo permiso">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Tipo
                        </SoftTypography>
                      </InputLabel>
                      <Select
                        variant="outlined"
                        defaultValue={"todos"}
                        onChange={(e) => setFiltro((prev) => ({ ...prev, tipo: e.target.value }))}
                        value={filtro.tipo}
                      >
                        <MenuItem value="todos">Todos</MenuItem>
                        <MenuItem value="Operador cinegético">Operador cinegético</MenuItem>
                        <MenuItem value="Coto">Coto</MenuItem>
                      </Select>
                    </SoftBox>
                    <SoftBox
                      mr={{
                        xs: 0,
                        sm: 2,
                      }}
                      mt={{
                        xs: 2,
                        sm: 0,
                      }}
                      sx={{
                        width: {
                          xs: "100%",
                          xl: "auto",
                        },
                      }}
                    >
                      <SoftInput
                        placeholder="Escribe aquí..."
                        icon={{ component: "search", direction: "left" }}
                        onChange={handleSearch}
                      />
                    </SoftBox>
                    <SoftBox
                      display={{
                        xs: "none",
                        sm: "block",
                      }}
                    >
                      <Tooltip title="Agregar nuevo usuario" placement="top">
                        <SoftButton
                          color="primary"
                          disabled={!verificarAcceso(1)}
                          onClick={() => setOpenModalAdd(true)}
                        >
                          <Icon>add</Icon>
                          &nbsp;Nuevo
                        </SoftButton>
                      </Tooltip>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </Grid>
            </Grid>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <Loading />
              ) : rows?.length > 0 ? (
                <DataTable columns={columns} rows={rows} order={orderBy} setOrder={handleOrderBy} />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loading}
              length={data?.permisosOcCoto?.length}
              total={pagesInfo?.total}
              pages={pagesInfo?.pages}
              page={page}
              setPage={setPage}
              noCard
            />
          </Card>
          {renderMenu}
          <ModalAdd
            open={openModalAdd}
            handleClose={() => {
              setOpenModalAdd(false);
              setSelectedPermiso();
            }}
            refetch={refetch}
            selectedPermiso={selectedPermiso}
            tipo="Empleado"
          />
          <ModalDelete
            open={openModalDelete}
            handleClose={() => {
              setOpenModalDelete(false);
            }}
            nombre={`el permiso de ${selectedPermiso?.personaHabilitada}`}
            functionDelete={() => {
              handleDeletePermiso(selectedPermiso?.id);
              setOpenModalDelete(false);
            }}
          />
          <ModalPermisoPDF
            open={openModalPDF}
            handleClose={() => setOpenModalPDF(false)}
            idPermiso={selectedPermiso?.id}
          />
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PermisosOcCoto;
